import { Injectable, signal } from '@angular/core';
import { StreamKind } from '../../../core/services/stream-health.service';

/** Which user's streams the stream stats dialog shows, and the first tab. */
export interface StreamStatsRequest {
  userId: string;
  kind: StreamKind;
}

/** Opens the app-wide stream stats dialog from tiles and the connection panel. */
@Injectable({ providedIn: 'root' })
export class StreamStatsDialogService {
  private readonly _request = signal<StreamStatsRequest | null>(null);
  readonly request = this._request.asReadonly();

  open(userId: string, kind: StreamKind): void {
    this._request.set({ userId, kind });
  }

  close(): void {
    this._request.set(null);
  }
}
